export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14304.4de0c147.jpg";